import Link from 'next/link';
import { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import MetaSeo from '../MetaSeo';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { getAllCategory, getPosts } from '../../redux/actions/news';
import useTrans from '../../hooks/useTrans';
import { getListPostHot, getListPostNew } from '../../redux/actions/news';
import { useRouter } from 'next/router';
import Router from 'next/router';

export default function News(props) {
  const [rows, setRows] = useState(props.rows || []);
  const [total, setTotal] = useState(props.total || 0);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [category_name, setCategoryName] = useState('');
  const [list_new, setListNew] = useState([]);
  // const [list_new_post, setListNewPost] = useState([]);
  // const [total_new_post, setTotalNewPost] = useState();
  const router = useRouter();
  const dispatch = useDispatch();
  const trans = useTrans();
  const submitSearch = async event => {
    event.preventDefault();
    const data = await getPosts(
      { name: search?.trim(), page: 1, category: category_name },
      dispatch,
    );
    setPage(1);
    setTotal(data.total);
    setRows(data.rows);
  };
  const closeCategory = async () => {
    setCategoryName('');
    const data = await getPosts(
      { name: search?.trim(), page: 1, category: '' },
      dispatch,
    );
    setPage(1);
    setTotal(data.total);
    setRows(data.rows);
  };
  const onEnterkey = e => {
    if (e.key === 'Enter') {
      submitSearch();
    }
  };
  const { category } = useSelector(state => {
    return {
      category: state.news.category,
    };
  }, shallowEqual);
  const getNewHot = async locale => {
    const data = await getListPostHot({ sign: locale });
    setListNew(data);
  };
  // const getPostNew = async locale => {
  //   const data = await getListPostNew({ sign: locale });
  //   if (data) {
  //     // setListNewPost(data.rows);
  //     setTotalNewPost(data.total);
  //   }
  // };
  useEffect(() => {
    // getListProjectFeatureHome(router.locale);
    // getListJobSlide();
    getNewHot(router.locale);
    // getPostNew(router.locale);
  }, [router.locale]);
  useEffect(() => {
    setRows(props.rows);
    setTotal(props.total);
    setCategoryName('');
    setPage(1);
    getAllCategory({}, dispatch);
  }, [dispatch, props]);
  // const stripHtml = (html) => {
  //     let tmp = document.createElement('p');
  //     tmp.innerHTML = html;
  //     return tmp.textContent || tmp.innerText || '';

  // };
  const loadMore = async () => {
    let new_page = parseInt(page) + 1;
    setPage(new_page);
    const data = await getPosts(
      {
        page: new_page,
        limit: 3,
        name: search?.trim(),
        category: category_name,
      },
      dispatch,
    );
    if (data) {
      const new_data = [...rows, ...data.rows];
      setRows(new_data);
    }
  };
  const getPostByCategory = async name => {
    const data = await getPosts(
      { category: name, name: search?.trim() },
      dispatch,
    );
    setCategoryName(name);
    if (data) {
      setRows(data.rows);
      setTotal(data.total);
    }
  };
  const filterTag = async tag_name => {
    let new_search = `#${tag_name}`;
    setSearch(new_search);
    const data = await getPosts({ name: new_search, page: 1 }, dispatch);
    setPage(1);
    setTotal(data.total);
    setRows(data.rows);
  };

  // if (list_new.length < 3) {
  //     return null;
  // }
  // const list_small1 = list_new.slice(0, 1) || [{}];
  // const list_small2 = list_new.slice(1, 3) || [{}, {}];
  const dataSEO = {
    title: `${trans.layout.news} | EYEFIRE`,
    description: trans.seo.news.description,
  };
  return (
    <>
      <MetaSeo {...dataSEO} />
      <section className="p-news">
        {/* <div className="c-big-banner">
                    <div className="c-big-banner__image">
                        <img className="w-100" src="/assets/img/news/img_big-banner.jpg" alt="" />
                    </div>
                    <div className="c-big-banner__inner">
                        <div className="l-container">
                            <div className="c-big-banner__content">
                                <h3>{trans.news.news}</h3>
                                <p>{trans.news.new_des}</p>
                            </div>
                        </div>
                    </div>
                </div> */}
        <div className="p-news__featured">
          <div className="l-container">
            <div className="c-title">
              <h3>{trans.news.new_hot}</h3>
              <p
                dangerouslySetInnerHTML={{
                  __html: `${trans.news.new_hostlist}`,
                }}
              ></p>
            </div>
            <div className="l-row">
              {list_new.length ? (
                <div className="l-col l-col-8">
                  {/* <Link href={`/${props.sign}/news/${item.seo_url}`}> */}
                  <a
                    href={`/${props.sign}/news/${list_new[0].seo_url}`}
                    className="p-news__featured-item"
                  >
                    <img className="w-100" src={list_new[0].image} alt="" />
                    <h3>
                      {list_new[0].title}
                      <div className="p-home__news--date">
                        <p>
                          <span className="p-home__news--date-text">
                            {list_new[0].postcategory?.name}
                          </span>{' '}
                          <span>
                            {moment(list_new[0]?.show_date).format(
                              'DD/MM/YYYY',
                            )}
                          </span>
                        </p>
                      </div>
                    </h3>
                  </a>
                  {/* </Link> */}
                </div>
              ) : null}
              <div className="l-col l-col-4">
                {list_new.length
                  ? list_new.map((item, index) => {
                      return index !== 0 && index < 3 ? (
                        <div className="news-item">
                          <a
                            href={`/${props.sign}/news/${item.seo_url}`}
                            className="p-news__featured-item"
                            style={{
                              height: '100%',
                            }}
                          >
                            <img
                              className="w-100"
                              src={item.image}
                              alt=""
                              style={{
                                height: '100%',
                                borderRadius: '7px',
                              }}
                              title={item.title}
                            />
                            {/* <div className="p-home__news-info"> */}
                            <h4>
                              {item.title}
                              <div className="p-home__news--date">
                                <p>
                                  <span className="p-home__news--date-text">
                                    {item.postcategory?.name}
                                  </span>{' '}
                                  <span>
                                    {moment(item?.show_date).format(
                                      'DD/MM/YYYY',
                                    )}
                                  </span>
                                </p>
                              </div>
                            </h4>

                            {/* </div> */}
                          </a>
                        </div>
                      ) : null;
                    })
                  : ''}
              </div>
            </div>
          </div>
        </div>
        <div className="p-news__lastest">
          <div className="l-container">
            <div className="p-news__lastest-top">
              <div className="l-row">
                <div className="l-col l-col-8">
                  <div className="title-left">
                    <h3>{trans.news.list_hot}</h3>
                    {category_name && (
                      <div className="handleBtnClose">
                        <a
                          onClick={() => {
                            closeCategory();
                          }}
                        >
                          {category_name}
                        </a>
                      </div>
                    )}
                  </div>
                </div>
                <div className="l-col l-col-4">
                  <div className="search">
                    <form>
                      <input
                        type="text"
                        placeholder="Tìm kiếm"
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                      />
                      <button onClick={submitSearch}>
                        <svg
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M21 21L16.514 16.506L21 21ZM19 10.5C19 12.7543 18.1045 14.9163 16.5104 16.5104C14.9163 18.1045 12.7543 19 10.5 19C8.24566 19 6.08365 18.1045 4.48959 16.5104C2.89553 14.9163 2 12.7543 2 10.5C2 8.24566 2.89553 6.08365 4.48959 4.48959C6.08365 2.89553 8.24566 2 10.5 2C12.7543 2 14.9163 2.89553 16.5104 4.48959C18.1045 6.08365 19 8.24566 19 10.5V10.5Z"
                            stroke="#A7A7A7"
                            strokeWidth={2}
                            strokeLinecap="round"
                          />
                        </svg>
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div className="p-news__lastest-list">
              {rows.length > 0 ? (
                rows.map(item => {
                  return (
                    <div className="p-news__lastest-item">
                      <div className="l-row">
                        <div className="l-col l-col-4">
                          <a
                            href={`/${props.sign}/news/${item.seo_url}`}
                            style={{ height: '100%' }}
                          >
                            <img
                              className="w-100"
                              src={item.image}
                              alt=""
                              style={{ height: '258px' }}
                              title={item.title}
                            />
                          </a>
                        </div>
                        <div className="l-col l-col-8">
                          <div className="newsList_textContent">
                            <div
                              className="newsList_textContent_title"
                              style={{ marginBottom: '15px' }}
                            >
                              <h3>
                                <Link
                                  href={`/${props.sign}/news/${item.seo_url}`}
                                >
                                  {item.title}
                                </Link>
                              </h3>
                            </div>
                            {/* <div className='cateAnddte'>
                          <span
                            onClick={() =>
                              getPostByCategory(item?.postcategory?.name)
                            }
                            className="p-news__lastest-item-catalog"
                          >
                            {item?.postcategory?.name}
                          </span>
                          <span className="p-news__lastest-item-time">
                            {moment(item?.show_date || item?.createdAt).format(
                              'DD/MM/YYYY',
                            )}
                          </span>
                          </div> */}
                            <div
                              className="p-home__news--date"
                              // style={{ marginBottom: '10px' }}
                            >
                              <p>
                                <span
                                  className="p-home__news--date-text"
                                  onClick={() =>
                                    getPostByCategory(item?.postcategory?.name)
                                  }
                                >
                                  {item.postcategory?.name}
                                </span>{' '}
                                <span>
                                  {moment(item?.show_date).format('DD/MM/YYYY')}
                                </span>
                              </p>
                            </div>
                            <div
                              className="newsList_textContent_content"
                              style={{ marginBottom: '20px' }}
                            >
                              <p className="content-news">
                                {item?.html_content}
                              </p>
                            </div>
                          </div>
                          {/* <div
                            onClick={() =>
                              getPostByCategory(item?.postcategory?.name)
                            }
                            className="p-news__lastest-item-catalog"
                          >
                            {item?.postcategory?.name}
                          </div> */}
                          {/* <h3>
                            <Link href={`/${props.sign}/news/${item.seo_url}`}>
                              {item.title}
                            </Link>
                          </h3> */}

                          {/* <div className="p-news__lastest-item-time">
                            {moment(item?.show_date || item?.createdAt).format(
                              'DD/MM/YYYY',
                            )}
                          </div> */}
                          {/* <p className="content-news">{item?.html_content}</p> */}
                          <div className="p-news__lastest-tag">
                            {item.tag
                              ? item.tag.map((tag, index) => {
                                  return (
                                    <a
                                      key={index}
                                      // onClick={() => filterTag(tag.tag.name)}
                                    >
                                      {tag.tag.name}
                                    </a>
                                  );
                                })
                              : null}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div id="not-found">
                  <div className="main-content">
                    <div className="container">
                      <div className="inner">
                        <div className="image">
                          <img
                            src="/assets/img/common/img_not-found.png"
                            alt="404-search.png"
                          />
                        </div>
                        <h3>
                          {/* {trans.project.no_result} */}
                          Không có kết quả tìm kiếm
                        </h3>
                        <Link href="/" className="btn-back">
                          {/* {trans.project.back_home} */}
                          <a> Quay về trang chủ</a>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {rows.length < total && (
                <div className="p-news__lastest__btn-viewmore">
                  <a onClick={() => loadMore()} className="c-btn">
                    {trans.text_button.read_more}
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
